(function () {
  var swiper = new Swiper(".teabo-carousel-image", {
    loop: true,
    slidesPerView: 2,
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      575: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 3,
      },
      1000: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    }
  });
  
})()